import React, {useState, useCallback, useEffect, use} from "react"

import OptionsSelector from "./OptionsSelector.jsx";

export default ({productHandle, variants, vehicles, onSelect}) => {

  const [selectOptions, setSelectOptions] = useState([]);
  const [optionsArray, setOptionsArray] = useState([]);

  useEffect(() => {
      const optionsArray = [];

      let variantIds = variants.map(variants => variants.id);
      let presumedVehicleVariants = [...variants]; // section of variants with a presumed vehicle
      let newVariants = [...variants]; // actual section of variants based on selected options

      if(vehicles && vehicles.length > 0){
        let newVehicles = [...vehicles];

        //collect body styles and filter vehicles in the same loop
        const bodyStyles = [];
        newVehicles = newVehicles.filter((vehicle) => {
          //collect bodyStyles
          const bodyStyle = bodyStyles.find(({value}) => value == vehicle.body_style );
          if(bodyStyle){
            bodyStyle.variants = fullOuterJoin(bodyStyle.variants, innerJoin(vehicle.allProducts, variantIds));
          }else{
            bodyStyles.push({
              value: vehicle.body_style,
              variants: innerJoin(vehicle.allProducts, variantIds)
            });
          }

          //filter vehicles
          if(selectOptions[0] && vehicle.body_style != selectOptions[0]){
            return false;
          }
          return true;
        });
        const bodyStyleVariants = bodyStyles.map(({variants}) => variants.sort().join(","));
        const uniqueBodyStyleVariantSets = [...new Set(bodyStyleVariants)];
        optionsArray.push({ 
          title: "Body Style",
          uniqueSets: uniqueBodyStyleVariantSets,
          optionIndex: -1,
          values: bodyStyles
        });

        //collect bed lengths
        const bedLengths = [];
        newVehicles = newVehicles.filter((vehicle) => {          
          //collect bedLengths
          const bedLength = bedLengths.find(({value}) => value == vehicle.bed_length );
          if(bedLength){
            bedLength.variants = fullOuterJoin(bedLength.variants, innerJoin(vehicle.allProducts, variantIds));
          }else{
            bedLengths.push({
              value: vehicle.bed_length,
              variants: innerJoin(vehicle.allProducts, variantIds)
            });
          }

          //filter vehicles
          if(selectOptions[1] && vehicle.bed_length != selectOptions[1]){
            return false;
          }
          return true;
        });
        const bedLengthVariants = bedLengths.map(({variants}) => variants.sort().join(","));
        const uniquebedLengthVariantSets = [...new Set(bedLengthVariants)];
        optionsArray.push({ 
          title: "Bed Length",
          uniqueSets: uniquebedLengthVariantSets,
          optionIndex: -1,
          values: bedLengths 
        });

        if(newVehicles.length == 0){
          setValue(1)(null);
        }

        //filter variants to only ones that work with remaining vehicles
        newVariants = newVariants.filter((variant) => {
          const matchingVehicle = newVehicles.find((vehicle)=>{
            if(vehicle.allProducts?.includes(variant.id.toString())){
              return true;
            }
          });
          return matchingVehicle;
        });

        //filter vehicles by selected options or first vehicle
        presumedVehicleVariants = newVariants.filter((variant) => {
          // use first vehicle to filter out variants for options so you don't get options that overlap vehicle selection
          const vehicle = newVehicles[0];
          if(vehicle && !vehicle.allProducts?.includes(variant.id.toString())){
            return false;
          }
          return true;
        });
      }

      const shopifyOptionsArray = [];
      newVariants.forEach(({options}) => {
        options.forEach(({name, value}, index) => {
          shopifyOptionsArray[index] = shopifyOptionsArray[index] || { values: [], title: name }
          const optionExists = shopifyOptionsArray[index].values.find((option) => option.value == value);
          if(optionExists){
            return;
          }
          shopifyOptionsArray[index].optionIndex = index;
          shopifyOptionsArray[index].values.push({
            value: value,
          });
        })
      });

      // finish collecting options based on a presumedVehicleVariants so we don't see options covered by vehicle selection
      const optionsOffset = optionsArray.length;
      presumedVehicleVariants.forEach(({options}) => {
        options.forEach(({name, value}, index) => {
          const arrayIndex = index + optionsOffset;
          optionsArray[arrayIndex] = optionsArray[arrayIndex] || { values: [], title: name }
          const optionExists = optionsArray[arrayIndex].values.find((option) => option.value == value);
          if(optionExists){
            return;
          }
          optionsArray[arrayIndex].optionIndex = index;
          optionsArray[arrayIndex].values.push({
            value: value,
          });
        })
      });

      // use options array to see if we can auto select a variant
      if(typeof onSelect == 'function'){
        
        const filteredVariants = variants.filter((variant) => {

          for(let i = 0; i < shopifyOptionsArray.length; i++){
            let option = selectOptions[i + optionsOffset];
            if(!option && shopifyOptionsArray[i]?.values?.length == 1){
              // Presume selection if only one option available
              option = shopifyOptionsArray[i].values[0].value;
            }
            
            const optionIndex = shopifyOptionsArray[i].optionIndex;
            if(option && optionIndex > -1 && option != variant.options[optionIndex].value){
              return false;
            }
          }
          return true;
        });

        if(filteredVariants.length == 1){
          onSelect(filteredVariants[0]);
        }
      }

      setOptionsArray(optionsArray);

  }, [variants, vehicles, selectOptions]);

  const setValue = useCallback((index) => (value) => {
    const newOptions = [...selectOptions];
    newOptions[index] = value;
    setSelectOptions(newOptions);
  }, [variants, selectOptions, optionsArray]);

  return <div className="drawer-customizer__product-options">
    {optionsArray.map(({title, values, uniqueSets}, index) => {
      if(values.length <= 1 || uniqueSets?.length <= 1){
        return null;
      }
      values.forEach((val)=>{
        val.selected = selectOptions[index] == val.value;
      });
      return <OptionsSelector key={`optionSelection-${index}`} productHandle={productHandle} title={title} values={values} setValue={setValue} index={index} />
    })}
  </div>
}

function fullOuterJoin(arr1, arr2) {
  return Array.from(new Set([...arr1, ...arr2]));
}

function innerJoin(arr1, arr2) {
  const set2 = new Set(arr2);
  return arr1.filter(item => set2.has(item));
}